import React from 'react';
import './Category.css';

const category = (props) => {
  let itemClass = "category";
  itemClass += props.isFocused ? " category-selected" : "";

  return (
    <div
      onClick={props.clicked}
      className={itemClass}>
      <span>{props.label}</span>
    </div>
  )
}

export default category;



// WEBPACK FOOTER //
// ./src/views/PickerView/components/list/Category.js